export const REACT_APP_API_KEY='';
export const REACT_APP_AUTH_DOMAIN='*.firebaseapp.com';
export const REACT_APP_DATABASE_URL='https://*.firebaseio.com';
export const REACT_APP_PROJECT_ID='';
export const REACT_APP_STORAGE_BUCKET='';
export const REACT_APP_MESSAGING_SENDER_ID='';
export const REACT_APP_APP_ID='';
